import React, { useState } from 'react'
import GradientUnderline from '../../../Components/GradientUnderline/GradientUnderline'
import GeneralAccess from './assets/general-card-front.png'
import VipAccess from './assets/vip-card-front.png'
import PremiumAccess from './assets/vip-premium-card-front.png'
import SecretClub from './assets/color-bg.png'
import GeneralAccessVideo from './assets/general-access-nft.mp4'
import VipPremiumAccessVideo from './assets/vip-premium-access-nft.mp4'
import SecretClubVideo from './assets/secretclub.mp4'
import VipAccessVideo from './assets/vip-access-nft.mp4'
import './GetAccess.scss'
import NFTInfoCard from './NFTInfoCard'
import { ReactComponent as PhysicsIco } from './assets/physics.svg'
import SliderGrab from '../../../Components/SliderGrab/SliderGrab'

import lipo_token from './assets/lipo_token.png'

const data = [
  {
    card: GeneralAccess,
    title: 'General Access Features',
    description:
      'Whether you’re a seasoned marketer or just starting out, the General Access offers the support, motivation, and knowledge you need to succeed.',
    bonuses: [
      'Event Access: December 2nd - 3rd',
      'Afterparty: December 3rd',
      ' FREE Souvenir Gift (pickup at event)',
      '195 $LIPO',
    ],
    oldPrice: 0,
    newPrice: 299,
    cardVideo: GeneralAccessVideo,
    nftCollection: 'Barcelona General Access NFT',
    nftMainCollection: '',
    nftCardTitle: 'NFT Bonus',
    nftBonus: [
      {
        value: 195,
        subtext: '',
        label: '$LIPO',
        ico: lipo_token,
      },
    ],
    mainGradient: 'linear-gradient(to right, #0d52a2, #3483c7)',
    bonusGradient: `linear-gradient(to right, ${'#3065A3'}, ${'#3450C7'})`,
    mainColor: 'rgb(60 103 255)',
    cardMainTitle: '⏳ ONLY 70 TICKETS AVAILABLE',
    secondaryColor: 'rgb(0, 167, 255)',
    hasTwoButtons: false,
    countdownDate: '2023-04-10 15:00',
    specialGradient: 'linear-gradient(to left, #5eff5a, #009dff)',
    shopUrl: 'https://shop.zixxar.net/product/Barcelona-General-Access',
  },
  {
    card: VipAccess,
    title: 'VIP Features',
    description:
      'The VIP experience is designed for those who are serious about taking their business to the next level.',
    bonuses: [
      'Meet & Greet: December 1st',
      'Front Seats: December 2nd-3rd',
      'Afterparty: December 3rd',
      'Accomodation reimbursement: up to $250',
      'FREE IMPulse K1 (pickup at event)',
      'FREE Souvenir Gift (pickup at event)',
      '650 $LIPO',
    ],
    oldPrice: 999,
    newPrice: 999,
    cardVideo: VipAccessVideo,
    nftCollection: 'Barcelona VIP Access NFT',
    nftMainCollection: '',
    nftCardTitle: 'NFT Bonus',
    nftBonus: [
      {
        value: 650,
        subtext: '',
        label: '$LIPO',
        ico: lipo_token,
      },
    ],
    mainGradient: 'linear-gradient(to right, #A33430, #C78334)',
    bonusGradient: `linear-gradient(to right, ${'#A33430'}, ${'#C78334'})`,
    mainColor: '#FFA63F',
    cardMainTitle: '⏳ ONLY 50 TICKETS AVAILABLE',
    secondaryColor: '#FFA63F',
    hasTwoButtons: false,
    countdownDate: '2023-04-10 15:00',
    specialGradient: 'linear-gradient(to right, #FFE13F, #FFA63F, #FF8023)',
    shopUrl: 'https://shop.zixxar.net/product/Barcelona-VIP-Access',
  },
  {
    card: PremiumAccess,
    title: 'Premium VIP Features',
    description:
      'Exclusive access to the industry’s Top Leaders & Experts and get insider insights to you achieve your goals.',
    bonuses: [
      'Meet & Greet: December 1st',
      'Front Seats: December 2nd-3rd',
      'Afterparty: December 3rd',
      'Transport & Accomodation reimbursement: up to $700',
      'FREE BASM (pickup at event)',
      'FREE HidR (pickup at event)',
      'FREE Souvenir Gift (pickup at event)',
      '2.600 $LIPO',
    ],
    oldPrice: 3990,
    newPrice: 3990,
    cardVideo: VipPremiumAccessVideo,
    nftCollection: 'Barcelona VIP Premium Access NFT',
    nftMainCollection: '',
    nftCardTitle: 'NFT Bonus',
    nftBonus: [
      {
        value: 2600,
        subtext: '',
        label: '$LIPO',
        ico: lipo_token,
      },
    ],
    mainGradient: 'linear-gradient(to right, #309FA3, #34C756)',
    bonusGradient: `linear-gradient(to right, ${'#309FA3'}, ${'#34C756'})`,
    mainColor: '#0083AA',
    cardMainTitle: '⏳ ONLY 25 TICKETS AVAILABLE',
    secondaryColor: '#5EFF5A',
    hasTwoButtons: false,
    countdownDate: '2023-04-10 15:00',
    specialGradient: 'linear-gradient(to left, #5eff5a, #009dff)',
    shopUrl: 'https://shop.zixxar.net/product/Barcelona-VIP-Premium-Access',
  },
  {
    card: SecretClub,
    title: 'Secret Club Features',
    description:
      'Gaining access to a club whose benefits, offerings, and returns will highly increase over time. ',
    bonuses: [
      'Front Seats',
      'Souvenir Gift',
      'Accomodation',
      'Meet & Greet Party',
      'Dinner & Lunch with Team & Special Guests',
    ],
    cardVideo: SecretClubVideo,
    nftCollection: 'Secret Club NFT',
    nftMainCollection: 'Secret Club Collection',
    nftCardTitle: 'NFT Bonus',
    nftBonus: [
      // {
      //     value: 600,
      //     subtext: "cycles",
      //     label: "Mining Power",
      //     ico: lipo_token,
      // },
    ],
    mainGradient: 'linear-gradient(to right, #A27D6F, #975640)',
    bonusGradient: `linear-gradient(to right, ${'#A27D6F'}, ${'#975640'})`,
    mainColor: '#00681a',
    cardMainTitle: '',
    secondaryColor: '#A27D6F',
    hasTwoButtons: true,
    specialGradient: 'linear-gradient(to right, #FFE13F, #FFA63F, #FF8023)',
  },
]

const GetAccess = () => {
  const view1 = <NFTInfoCard data={data[0]} />
  const view2 = <NFTInfoCard data={data[1]} />
  const view3 = <NFTInfoCard data={data[2]} />
  const view4 = <NFTInfoCard data={data[3]} />

  const [triggerAnimation, setTriggerAnimation] = useState(false)
  const [triggerAnimation2, setTriggerAnimation2] = useState(false)
  const [view, setView] = useState({
    index: 1,
    view: view1,
  })

  const handleViewChange = (viewIndex, view) => {
    setView(prev => ({ ...prev, index: viewIndex }))
    setTriggerAnimation(true)
    setTimeout(() => {
      setTriggerAnimation(false)
      setTriggerAnimation2(true)
      setView({
        index: viewIndex,
        view: view,
      })
    }, 400)
    setTimeout(() => {
      setTriggerAnimation2(false)
    }, 800)
  }

  return (
    <div id='event-get-access' className='event-get-acces'>
      <div className='large-container d-flex align-items-center gap-3 justify-content-center flex-column'>
        <div className='large-container d-flex align-items-center justify-content-center flex-column gap-3'>
          <h2 className='font-pnb font-size-64 text-center lh-1'>
            Get access to:
          </h2>
          <GradientUnderline />
          <span className='color-light-grey font-size-18 text-center mb-3'>
            The world's top affiliate marketers and ecommerce entrepreneurs.
          </span>
        </div>
        <div className='w-100 d-flex desktop-cards align-items-start justify-content-start gap-3 flex-column'>
          {data.map((el, i) => {
            return (
              <React.Fragment key={'nft-card-' + i}>
                <NFTInfoCard data={el} />
              </React.Fragment>
            )
          })}
        </div>
        <div className='w-100 d-flex mobile-cards align-items-start justify-content-start gap-3 flex-column'>
          <SliderGrab>
            <div className='d-flex w-100 align-items-start justify-content-start justify-content-md-center gap-1 gap-sm-3'>
              <button
                className={`nft-btn ${view.index === 1 ? 'active' : 'grayed'}`}
                onClick={() => handleViewChange(1, view1)}
              >
                <img
                  src={GeneralAccess}
                  alt='general access'
                  className='action-img-btn'
                />
              </button>
              <button
                className={`nft-btn ${view.index === 2 ? 'active' : 'grayed'}`}
                onClick={() => handleViewChange(2, view2)}
              >
                <img
                  src={VipAccess}
                  alt='general access'
                  className='action-img-btn'
                />
              </button>
              <button
                className={`nft-btn ${view.index === 3 ? 'active' : 'grayed'}`}
                onClick={() => handleViewChange(3, view3)}
              >
                <img
                  src={PremiumAccess}
                  alt='general access'
                  className='action-img-btn'
                />
              </button>
              <button
                className={`nft-btn ${view.index === 4 ? 'active' : 'grayed'}`}
                onClick={() => handleViewChange(4, view4)}
              >
                <img
                  src={SecretClub}
                  alt='general access'
                  className='action-img-btn'
                />
              </button>
            </div>
          </SliderGrab>
          <div
            className={`view-container w-100 h-100 d-flex align-items-center justify-content-center ${
              triggerAnimation ? 'animate-out' : ''
            } ${triggerAnimation2 ? 'animate-in' : ''} `}
          >
            {view.view}
          </div>
        </div>
      </div>
      <div className='container py-3'>
        <div className=''>
          Please see our event Terms & Conditions{' '}
          <a href='https://zixxar-incentive-builder.s3.eu-central-1.amazonaws.com/ZiXXar_Event_Participation_Terms_and_Conditions.pdf'>
            here
          </a>{' '}
          and our ticket Terms & Conditions{' '}
          <a href='https://zixxar-incentive-builder.s3.eu-central-1.amazonaws.com/GlobalZiXXar_Ticket_Terms_and_Conditions.pdf'>
            here
          </a>
          .
        </div>
      </div>
    </div>
  )
}
export default GetAccess
